
import { AsgardDocPdf } from 'src/app/core/documents/asgard-doc-pdf';
import { AsgardCommandBase } from '../command-base';
import { Core } from '@pdftron/webviewer';

export class TextAnnotationCommand extends AsgardCommandBase {
    private nextValue: Core.Annotations.Annotation[] | null = null;
    public set nextValueRecieved(annots: Core.Annotations.Annotation[]) {
        this.nextValue = annots;
    }

    constructor(
        public doc: AsgardDocPdf,
        private annot: Core.Annotations.Annotation
    ) {
        super(doc);
    }

    async execute() {
        if (!this.nextValue) {
            console.warn('Pending value not recieved');
            return;
        }
        await this.doc.rawDeleteAnnotations([this.annot]);
        return await this.doc.rawAddAnnotations(this.nextValue);
    }

    async undo() {
        if (this.nextValue) {
            await this.doc.rawDeleteAnnotations(this.nextValue);
        }
        return await this.doc.rawAddAnnotations([this.annot]);
    }
}
